import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {MatSelectChange} from '@angular/material/select';
import {BaseSelectComponent} from "../base-select/base-select.component";

@Component({
    selector: 'app-custom-select',
    templateUrl: './custom-select.component.html',
    styleUrls: ['./custom-select.component.scss']
})
export class CustomSelectComponent extends BaseSelectComponent implements OnInit, OnChanges {
    public _result: any;

    @Input() emptyOption: string;
    @Input()
    get result(): any {
        return this._result;
    }
    set result(data: any) {
        if ((data === undefined || data === null) && this.emptyOption) {
            this._result = 'null';
        } else {
            this._result = data;
        }
    }


    constructor(cd: ChangeDetectorRef) {
        super(cd);
    }

    ngOnInit() {
        super.ngOnInit();
        this.checkOptionDataType();
    }

    private checkOptionDataType() {
        if (typeof this._result === 'number' && this.options && this.options.length > 0 &&
            typeof this.options[0][this.value] === 'string') {
            this._result = this._result.toString();
        } else if ((this._result === null || this._result === undefined) && this.emptyOption) {
            this._result = 'null';
        }
    }

    onSelectionChanged($event: MatSelectChange) {
        if ($event.value === 'null') {
            this.resultChange.emit(null);
        } else {
            this.resultChange.emit($event.value);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        if (changes.result !== undefined && changes.result.currentValue
        ) {
            if (typeof this._result === 'number' && this.options && this.options.length > 0 &&
                typeof this.options[0][this.value] === 'string') {
                this._result = this._result.toString();
            } else if ((this._result === null || this._result === undefined) && this.emptyOption) {
                this._result = 'null';
            }
        }

        if (changes.options !== undefined) {
            this.checkOptionDataType();
        }
    }
}
